<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
        <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />

        <label class="search-label">状态</label>
        <Select v-model="status" class="search-input" clearable>
          <Option v-for="item in statusIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">工作类型</label>
        <Select v-model="work_type_id" class="search-input" clearable>
          <Option v-for="item in workTypeIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">平台</label>
        <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">视频分类</label>
        <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable>
          <Option v-for="item in videoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">执行账号</label>
        <Select v-model="user_id" class="search-input" clearable filterable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <Button @click="handleButtonSearch" class="search-btn" type="primary">搜索</Button>
        <Button @click="showAddModal" type="primary" style="margin-left: 20px;">添加</Button>
        </Col>
      </Row>

      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]" show-sizer
            show-elevator @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>

    <Modal :mask-closable="false" v-model="addModal" title="添加语音转换" footer-hide>
      <forms :resetFlag="resetFlag" ref="addCovertAudioModal" @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal :mask-closable="false" v-model="editModal" title="编辑语音转换" footer-hide>
      <forms :resetFlag="resetFlag" ref="editCovertAudio" @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Forms from "./add_covert_audio_form.vue";
import Tables from "_c/tables/table-only.vue";
import saveAs from '@/api/FileSaver';

import {
  getCovertAudioList, finishCovertAudioTask, editCovertAudioTask,
  audioModelList, addCovertAudio, deleteCovertAudioTask, getShortVideoWorkTypeList,
  getShortVideoClassify, getLiveType, getStrategyUser, endCovertAudio, getCovertAudioDetail
} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat: false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      wxContacts: [],
      statusIds: [{ id: -1, name: "全部" }, { id: 0, name: "排队中" }, { id: 1, name: "转换中" }, { id: 2, name: "转换完成" }, { id: 3, name: "转换失败" }, { id: 4, name: "已完成" }, { id: 5, name: "任务终止" }],
      live: "",
      user: '',
      user_id: '',
      keyword: '',
      userIds: [],
      liveIds: [],
      workTypeIds: [],
      videoClassifyIds: [],
      live_id: '',
      work_type_id: '',
      video_classify_id: '',
      status: -1,
      columns: [
        {
          title: 'id', width: 100, align: "center", sortable: true,
          render: (h, params) => {
            let texts = params.row.translateText.checkSrtTask.shortVideoTask.id;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }
        },
        { title: "id", width: 100, key: "id", editable: true, align: "center" },
        {
          title: "自动化",
          key: "status",
          width: 100, align: "center",
          render: (h, params) => {
            var texts = "手动"
            if (params.row.translateText.checkSrtTask.shortVideoTask.auto) {
              texts = "自动"
            }
            return h(
              "div",
              {
                props: {},
                style: {
                  color: params.row.translateText.checkSrtTask.shortVideoTask.auto ? "#ff0000" : "#515a6e"
                }
              },
              texts
            );
          },
        },
        {
          title: "执行人", key: "nickname", editable: true, align: "center",
          render: (h, params) => {
            var texts = ""
            var list = params.row.translateText.list
            if (list.length != 0) {
              for (var i = 0; i < list.length; i++) {
                texts += list[i].username + "\n"
              }
            }
            return h(
              "pre",
              texts
            );
          }
        },
        {
          title: "语言", key: "work_type_name", editable: true, align: "center",
          render: (h, params) => {
            let texts = params.row.translateText.list[0].language;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }
        },
        {
          title: "类型", key: "work_type_name", editable: true, align: "center",
          render: (h, params) => {
            let texts = ''
            if (params.row.translateText != null) {
              if (params.row.translateText.checkSrtTask != null) {
                if (params.row.translateText.checkSrtTask.shortVideoTask != null) {
                  texts = params.row.translateText.checkSrtTask.shortVideoTask.work_type_name;
                }
              }
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }
        },
        {
          title: "分类", key: "video_classify", editable: true, align: "center",
          render: (h, params) => {
            let texts = ''
            if (params.row.translateText != null) {
              if (params.row.translateText.checkSrtTask != null) {
                if (params.row.translateText.checkSrtTask.shortVideoTask != null) {
                  texts = params.row.translateText.checkSrtTask.shortVideoTask.video_classify;
                }
              }
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }
        },
        {
          title: "标题", key: "", editable: true, align: "center",
          render: (h, params) => {
            let texts = ''
            if (params.row.translateText != null) {
              if (params.row.translateText.checkSrtTask != null) {
                if (params.row.translateText.checkSrtTask.shortVideoTask != null) {
                  texts = params.row.translateText.checkSrtTask.shortVideoTask.video_title;
                }
              }
            }
            return h('div', [
              // 显示的位置上方
              h('Tooltip', {
                props: { placement: 'top', transfer: true }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '70px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                }, texts),
                // 显示的内容
                h('span', {
                  slot: 'content',
                  style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                }, texts)
              ])
            ])
          }
        },
        { title: "声音模型", key: "source_audio_name", editable: true, align: "center" },
        {
          title: "字幕文件", key: "srt_path", editable: true, align: "center",
          render: (h, params) => {
            let status = false
            if (params.row.translateText != null) {
              if (params.row.translateText.checkSrtTask != null) {
                if (params.row.translateText.checkSrtTask.shortVideoTask != null) {
                  var short_video_work_type_id = params.row.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id
                  if (short_video_work_type_id == 7) {
                    status = false
                  }{
                    status = params.row.translateText.checkSrtTask.shortVideoTask.srt_status
                  }
                }
              }
            }

            return status ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.downloadSrt(params);
                    },
                  },
                },
                "下载"
              )
            ]): h('span', '');
          }
        },
        {
          title: "音频", key: "source_path", editable: true, align: "center", render: (h, params) => {
            return params.row.source_path && params.row.source_path.length > 0 != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.source_path);
                    },
                  },
                },
                "下载"
              )
            ]) : h('span', '');
          }
        },
        {
          title: "状态",
          key: "status",
          width: 100, align: "center",
          render: (h, params) => {
            var texts = "已完成"
            if (params.row.status == 0) {
              texts = "待处理"
            } else if (params.row.status == 1) {
              texts = "转换中"
            } else if (params.row.status == 2) {
              texts = "转换成功"
            } else if (params.row.status == 3) {
              texts = "转换失败"
            } else if (params.row.status == 5) {
              texts = "任务终止"
            }
            return h(
              "div",
              {
                props: {},
                style: {
                  color: params.row.status == 5 || params.row.status == 3 ? "#ff0000" : "#515a6e"
                }
              },
              texts
            );
          },
        },
        { title: "创建时间", key: "create_time", editable: true, align: "center" },
        { title: "完成时间", key: "finish_time", editable: true, align: "center" },
        {
          title: "Handle",
          key: "handle", align: "center",

          render: (h, params) => {
            return h("div", [
              params.row.status != 5 ? h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ) : h('span', ''),
              params.row.status == 2 && params.row.status != 5 ? h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleFinish(params);
                    },
                  },
                },
                "完成"
              ) : h('span', ''),
              params.row.status != 5 ? h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleEnd(params);
                    },
                  },
                },
                "终止"
              ) : h('span', ''),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.handleDelete(params);
              //       },
              //     },
              //   },
              //   "删除"
              // )
            ]);
          },
        }
      ],
      tableData: [],
    };
  },// 父组件中，监听路由变化来刷新数据
  watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch();
    }
  },
  methods: {
    handleButtonSearch() {
      this.page = 1
      this.handleSearch()
    },
    handleEnd(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认终止任务？</p>',
        onOk: () => {
          endCovertAudio(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    downloadSrt(params) {
      var params = {
        id: params.row.id
      }

      getCovertAudioDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          var fileName = ''

          var srt_path = detailData.srt_path

          if (srt_path){
            window.open(srt_path, '_blank');
          }else{
            var srtJson = detailData.srt_json
            fileName = "covert_audio_" + detailData.id + '.srt'
            var srt_array = JSON.parse(srtJson)
            var srtContent = this.generateSRT(srt_array)
            const blob = new Blob([srtContent], { type: 'text/plain' });

            // 保存文件
            saveAs(blob, fileName);
          }


        }
      });
    },
    generateSRT(subtitles) {
      let srtContent = '';
      subtitles.forEach((item, index) => {
        const sequenceNumber = index + 1;
        const startTime = item.startTime
        const endTime = item.endTime
        var new_text = ''
        if (item.new_text != null && item.new_text.length > 0) {
          new_text = item.new_text
        } else {
          if (item.update_translate_text != null && item.update_translate_text.length > 0) {
            new_text = item.update_translate_text
          } else {
            new_text = item.translate_text
          }
        }
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${new_text}\n\n`;
      });
      return srtContent;
    },

    download(url) {
      window.open(url, '_blank');
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
      audioModelList().then((res) => {
        var audioList = res.data.data.records;
        this.$refs.addCovertAudioModal.setAudioList(audioList);
      });
    }, showEditModal(params) {
      this.$router.push({ name: "cover_audio_form", query: { id: params.row.id } });

    }, addSumit(formValidate) {

      const data = {
        audio_model_id: formValidate.audio_model_id,
        srt_path: formValidate.srt_path,
        audio_path: formValidate.audio_path
      };
      addCovertAudio(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      var type = 1
      if (formValidate.type == '语音生成') {
        type = 0
      }
      const data = {
        video_path: formValidate.videoPath,
        audio_model_id: formValidate.audio_model_id,
        audio_path: formValidate.audio_path,
        source_path: formValidate.source_path,
        type: type
      };

      editCovertAudioTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() { },
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
        live_id: this.live_id,
        keyword: this.keyword,
        user_id: this.user_id,
        work_type: this.work_type_id,
        video_classify: this.video_classify_id
      };
      getCovertAudioList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    }, handleDelete(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除任务？</p>',
        onOk: () => {
          deleteCovertAudioTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    handleFinish(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认提交任务？</p>',
        onOk: () => {
          finishCovertAudioTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.$Message.success("成功!");
                this.handleSearch()
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    }, videoClassifyChange(value) {
      this.getStrategyUser()

    }, liveChange(value) {
      this.getStrategyUser()

    }, getStrategyUser() {
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data
      });
    }
  },
  mounted() {
    this.getStrategyUser()
    this.handleSearch();
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data;
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    });

    getShortVideoWorkTypeList().then((res) => {
      var workType = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.workTypeIds = data
    });

    getShortVideoClassify({}).then((res) => {
      var workType = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.videoClassifyIds = data
    });
  },
};
</script>
